import { Field, FormikErrors, FormikTouched } from "formik";
import styled, { css } from "styled-components";
import { style } from "./style";

export type InputProps = {
  type?: "text" | "email" | "password" | "tel" | "url";
  name: string;
  label: string;
  labelTooltip?: string;
  description?: string;
  value: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  loading?: boolean;
  error?: string | FormikErrors<any>;
  touched?: boolean | FormikTouched<any>;
  className?: string;
  mono?: boolean;
  readOnly?: boolean;
  isSecret?: boolean;
  iconLeft?: string;
  iconRight?: string;
};

type LabelProps = {
  $disabled?: boolean;
};

/**
 * @deprecated Use `TextInputV2` instead.
 */
export const Wrapper = styled.div`
  font-size: ${style.vars.fontSize.small};
  position: relative;
`;

/**
 * @deprecated Use `TextInputV2` instead.
 */
export const Label = styled.label<LabelProps>`
  /* Overwrite css styles */
  && {
    display: flex;
    align-items: center;
    letter-spacing: inherit;
    color: inherit;
    text-transform: inherit;
    opacity: ${({ $disabled }) => ($disabled ? "0.3" : "inherit")};
  }
`;

/**
 * @deprecated Use `TextInputV2` instead.
 */
export const InputWrapper = styled.div`
  position: relative;
  margin-top: ${style.vars.space["1"]};
  height: 100%;
  min-width: 250px;
  max-width: 700px;
`;

/**
 * @deprecated Use `TextInputV2` instead.
 */
export const BaseInput = styled(Field)<{ $mono?: boolean }>`
  /*
    In order to make our Input styles more specific than the default styles
    provided by GlobalWalrusStyle, we need to double up the current selector (.input.input)
  */
  && {
    ${({ $mono }) =>
      $mono &&
      css`
        font-family: ${style.vars.monoFont};
      `}

    &:hover {
      border-color: ${style.colors.blue.dark};
    }

    &:disabled {
      opacity: 0.3; /* Overwrite existing style */
      color: ${style.colors.grey.primary};
      border-color: ${style.colors.grey.primary};
      background-color: ${style.colors.grey.lightest};
      cursor: not-allowed;
    }

    &::placeholder {
      color: ${style.colors.grey.primary};
    }
  }

  ${Wrapper}.is-invalid & {
    border-color: ${style.colors.red.dark};
  }
`;

export const ErrorMessage = styled.div`
  margin-top: ${style.vars.space["1"]};
  display: flex;
  align-items: flex-start;
`;

/**
 * @deprecated Use `TextInputV2` instead.
 */
export const ErrorText = styled.div`
  font-weight: ${style.vars.fontWeight.bold};
  color: ${style.colors.red.dark};
  height: 100%;
`;

/**
 * @deprecated Use `TextInputV2` instead.
 */
export const RequiredAsterisk = styled.span`
  color: ${style.colors.blue.primary};

  ${Wrapper}.is-invalid & {
    color: ${style.colors.red.dark};
  }
`;

export const FocusOutline = styled.div`
  position: absolute;
  top: -${style.vars.space["1"]};
  left: -${style.vars.space["1"]};
  right: -${style.vars.space["1"]};
  bottom: -${style.vars.space["1"]};
  z-index: 0;
  opacity: 0;
  border: ${style.vars.borderWidth.base} dotted ${style.colors.grey.dark};
  border-radius: ${style.vars.borderRadius.base};

  ${BaseInput}:focus + & {
    opacity: 1;
  }
`;
